import { EditContribution } from './EditContribution';
import { CreateContribution } from './CreateContribution';

interface ContributionFormOverlayProps {
  onBack?: () => void;
  onClose: () => void;
  contributionGuid?: string;
}

export const ContributionFormOverlay = ({
  onClose,
  contributionGuid,
}: ContributionFormOverlayProps) => {
  if (contributionGuid) {
    return (
      <EditContribution contributionGuid={contributionGuid} onClose={onClose} />
    );
  }

  return <CreateContribution onClose={onClose} />;
};
